import * as React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Drawer from "@mui/material/Drawer";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";
import {
  Col,
  Row,
  FormGroup,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  Label,
  Input,
  InputGroup,
  FormFeedback,
  FormText,
} from "reactstrap";
import InputLabel from "@mui/material/InputLabel";

export default function CustomizedDialogs(props) {
  const { CIS_NUMBER, status, selected, itemgroupselected } = props;
  var cis_no = CIS_NUMBER;
  const IndualSubmit = (selected) => (e) => {
    e.preventDefault();
    let sub = {
      host_id: window.sessionStorage.getItem("hostID").toString(),
      remedy_id: window.sessionStorage.getItem("remedyID").toString(),
      tags: selected.toString(),
    };
    fetch(`${process.env.REACT_APP_API_URL}/api/run_rollback`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
      body: JSON.stringify(sub),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data.detail);
        window.location.href = "/admin/rollback";
      })
      .catch((error) => {
        console.log(error);
        window.location.href = "/admin/rollback";
      });
    window.location.href = "/admin/rollback";
  };

  return (
    <>
      <div>
        <button
          disabled={
            selected.length > 0 || itemgroupselected.length > 0 ? true : false
          }
          className={
            selected.length > 0 || itemgroupselected.length > 0
              ? "bg-blueGray-200 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
              : [
                  status === "ROLLEDBACKFAILED" || status === "PASSED"
                    ? "bg-red-600 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                    : status === "ROLLEDBACK"
                    ? "bg-emerald-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                    : "bg-blueGray-200 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150",
                ]
          }
          type="button"
          onClick={IndualSubmit(cis_no)}
        >
          {status === "ROLLEDBACKFAILED"
            ? "ROLLEDBACKFAILED"
            : status === "PASSED"
            ? "ROLLBACK"
            : "ROLLEDBACK"}
        </button>
      </div>
    </>
  );
}